import React, { Component } from "react";
import { authService } from "../auth";
import axios from "axios";
import _ from "lodash";
import alertPopUp from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content';
import stripHtml from "string-strip-html";

const ErorrMsgPopUp = withReactContent(alertPopUp);

const deleteConfirmFaq = () => {
    return ({
        title: "Are you sure you want to delete this FAQ?",
        focusConfirm: false,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancel',
        allowOutsideClick: false,
    })
};
class DonationAboutSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userData: authService.getUserDetailsFromLocalStorage(),
            description: this.props.donateNowConfig?.description,
            fundingPurpose: this.props.donateNowConfig?.description,
            fundRaiseFaq: [],
            faqQuestion: "",
            faqAnswer: "",
            openFaqSectionIndex: 0,
            showFaqAddSection: false,
            showFundingPurpose: false,
            editPurposeFunding: false,
            errors: {}
        }
    }

    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        })
    }

    validateForm = (type) => {
        let errors = {};
        let formIsValid = true;
        if (type === "FAQ") {
            if ((_.isUndefined(this.state.faqQuestion) || _.isEmpty((this.state.faqQuestion || "").toString()) || _.isNull(this.state.faqQuestion))) {
                errors["faqQuestion"] = "Please enter Question.";
                formIsValid = false;
            }
            if ((_.isUndefined(this.state.faqAnswer) || _.isEmpty((this.state.faqAnswer || "").toString()) || _.isNull(this.state.faqAnswer))) {
                errors["faqAnswer"] = "Please enter Answer.";
                formIsValid = false;
            }
        }
        if (type === "FUND_PURPOSE") {
            if ((_.isUndefined(this.state.fundingPurpose) || _.isEmpty((this.state.fundingPurpose || "").toString()) || _.isNull(this.state.fundingPurpose))) {
                errors["fundingPurpose"] = "Please enter Purpose of Funding.";
                formIsValid = false;
            }
            if(this.state.fundingPurpose && stripHtml(this.state.fundingPurpose).match(/\S+/g).length > 150) {
                errors["fundingPurpose"] = "Purpose of Funding should be within 150 words";
                formIsValid = false;
            }
        }
        this.setState({
            errors: errors,
        });
        {
            setTimeout(() => {
                this.setState({
                    errors: {},
                });
            }, 5000);
        }
        return formIsValid;
    }

    submitFundingPurpose = () => {
        if (this.validateForm("FUND_PURPOSE")) {
            let postData = {
                id: this.props.donateNowConfig?.id,
                userId: this.state.userData.userId,
                description: this.state.fundingPurpose,
                entityType: this.props.donateNowConfig?.type
            }
            axios({
                method: 'POST',
                url: `${process.env.REACT_APP_userServiceURL}/backend/donation/update/description`,
                headers: { 'Content-Type': 'application/json' },
                data: postData,
                withCredentials: true
            }).then(response => {
                if (response && response.data && response.data.message === 'Success!') {
                    this.setState({
                        description: this.state.fundingPurpose,
                    })
                    this.clickFundRaisePurposeFunding("showFundingPurpose");
                }
            }).catch((err) => {
                console.log(err);
            });
        }
    }

    submitFaqSectionData = () => {
        if (this.validateForm("FAQ")) {
            let postData = {
                donationId: this.props.donateNowConfig?.id,
                userId: this.state.userData.userId,
                question: this.state.faqQuestion,
                answer: this.state.faqAnswer,
                entityType: this.props.donateNowConfig?.type
            }
            axios({
                method: 'POST',
                url: `${process.env.REACT_APP_userServiceURL}/backend/donation/create/faq`,
                headers: { 'Content-Type': 'application/json' },
                data: postData,
                withCredentials: true
            }).then(response => {
                if (response && response.data && response.data.message === 'Success!') {
                    this.setState({
                        faqQuestion: "",
                        faqAnswer: ""
                    })
                    this.getDonateNowConfig();
                    this.clickFundRaisePurposeFunding("showFaqAddSection");
                }
            }).catch((err) => {
                console.log(err);
            });
        }
    }

    editFaqSectionData = (id) => {
        let fundRaiseFaqItemList = this.state.fundRaiseFaq;
        let postData = {
            donationId: this.props.donateNowConfig?.id,
            userId: this.state.userData.userId,
            faqId: id,
            entityType: this.props.donateNowConfig?.type
        }
        const index = fundRaiseFaqItemList && fundRaiseFaqItemList.findIndex((faq) => faq.id === id);
        if(index > -1) {
            postData.question = fundRaiseFaqItemList[index].question;
            postData.answer = fundRaiseFaqItemList[index].answer;
        }
        axios({
            method: 'POST',
            url: `${process.env.REACT_APP_userServiceURL}/backend/donation/update/faq`,
            headers: { 'Content-Type': 'application/json' },
            data: postData,
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.message === 'Success!') {
                this.cancelEditFaq();
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    clickFundRaisePurposeFunding = (sectionName) => {
        this.setState({
            [sectionName]: sectionName === "showFaqAddSection" ? !this.state.showFaqAddSection : !this.state.showFundingPurpose
        })
        if (sectionName === "showFundingPurpose") {
            this.setState({
                editPurposeFunding: false,
                showFaqAddSection: false,
                fundingPurpose: this.state.description
            })
        }
    }

    handleEditPurposeFunding = () => {
        this.setState({
            editPurposeFunding: true,
            showFundingPurpose: true
        })
    }

    deleteFaqSection = (id) => {
        let postData = {
            donationId: this.props.donateNowConfig?.id,
            userId: this.state.userData.userId,
            faqId: id,
            entityType: this.props.donateNowConfig?.type
        }
        axios({
            method: 'POST',
            url: `${process.env.REACT_APP_userServiceURL}/backend/donation/delete/faq`,
            headers: { 'Content-Type': 'application/json' },
            data: postData,
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.message === 'Success!') {
                let fundRaiseFaqItemList = this.state.fundRaiseFaq;
                const index = fundRaiseFaqItemList && fundRaiseFaqItemList.findIndex((faq) => faq.id === id);
                if (index > -1) {
                    fundRaiseFaqItemList.splice(index, 1);
                }
                this.setState({
                    fundRaiseFaq: fundRaiseFaqItemList
                })
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    deleteFaq = async (id) => {
        const swalval = await ErorrMsgPopUp.fire(deleteConfirmFaq());
        if(swalval && swalval.value === true) {
            this.deleteFaqSection(id);
        }
    }

    editFaq = (id) => {
        this.getDonateNowConfig(id);
    }

    getDonateNowConfig = (id) => {
        axios({
            method: 'GET',
            url: `${process.env.REACT_APP_userServiceURL}/donation/data?userId=${this.state.userData.userId}&entityId=${this.props.entityId}&entityType=${this.props.entityType}&requestingUserId=${this.state.userData.userId}`,
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.body && response.data.message === 'Success!') {
                this.getFaqDataDetails(response.data.body, id);
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    handleFaqEdit = (event, id, type) => {
        let fundRaiseFaqList = this.state.fundRaiseFaq;
        let index = fundRaiseFaqList && fundRaiseFaqList.findIndex((data) => data.id === id);
        if(index > -1) {
            if(type === "QUESTION") {
                fundRaiseFaqList[index].question = event.target.value
            } else {
                fundRaiseFaqList[index].answer = event.target.value
            }
        }
        this.setState({
            fundRaiseFaq: fundRaiseFaqList
        })
    }

    getFaqDataDetails = (faqData, id) => {
        if(id) {
            let fundRaiseFaqItemList = faqData && faqData.faq;
            const index = fundRaiseFaqItemList && fundRaiseFaqItemList.findIndex((faq) => faq.id === id);
            fundRaiseFaqItemList = fundRaiseFaqItemList.filter(data => { data.editFaqSection = false; return data;});
            if (index > -1) {
                fundRaiseFaqItemList[index].editFaqSection = true
            }
            this.setState({
                fundRaiseFaq: fundRaiseFaqItemList
            })
        } else {
            let fundRaiseFaqList = [];
            faqData && faqData.faq && faqData.faq.map((item) => {
                item.editFaqSection = false;
                fundRaiseFaqList.push(item);
            })
            this.setState({
                fundRaiseFaq: fundRaiseFaqList
            })
        }
    }

    cancelEditFaq = () => {
        this.getDonateNowConfig();
    }

    componentDidMount() {
        this.getFaqDataDetails(this.props.donateNowConfig);
    }

    render() {
        const { fundingPurpose, description, userData, fundRaiseFaq, faqQuestion, faqAnswer, openFaqSectionIndex, showFaqAddSection, errors, showFundingPurpose, editPurposeFunding } = this.state;
        const { donateNowConfig } = this.props;
        return (
            <div className="prjHmCommonSec prjHmFundRaise">
                <h2 className="title-center">About Fund Raise</h2>

                {(description || (donateNowConfig?.superAdminId === userData.userId)) &&
                    <div className="prjHmFR_purpose dgcard">
                        {description && !editPurposeFunding &&
                            <div className="descPreview">
                                <div className="titleBlk">
                                    <h3>Purpose of Funding</h3>
                                    {(donateNowConfig?.superAdminId === userData.userId) &&
                                        <a href="javascript:void(0)" onClick={this.handleEditPurposeFunding} className="edtbtn btn collapser" style={{ color: "#fff" }}><i className="iEditBox"></i> Edit</a>
                                    }
                                </div>
                                <p>{description}</p>
                            </div>
                        }

                        {(!description || editPurposeFunding) && donateNowConfig?.superAdminId === userData.userId &&
                            <div className={"pjaddjobsec prjHmFR_purpose_form" + (showFundingPurpose ? " current" : "")}>
                                {!editPurposeFunding &&
                                    <a href="javascript:void(0)" className="edtbtn btn collapser" onClick={(e) => this.clickFundRaisePurposeFunding("showFundingPurpose")}><i className="iEditBox"></i> Add why do you want to Raise Funds?</a>
                                }
                                <div className={"fadeIn animated profeditmain collapse" + (showFundingPurpose ? " show" : "")}>
                                    <textarea className="form-control" name={"fundingPurpose"} value={fundingPurpose} onChange={this.handleChange}></textarea>
                                    {errors["fundingPurpose"] && <span className="login-feedback-error mt-1" style={{ display: "block" }}>{errors["fundingPurpose"]}</span>}
                                    <div className='actionBtnWrap mt-3'>
                                        <button type="button" className="btn btn-primary ok" onClick={this.submitFundingPurpose}>{!editPurposeFunding ? "Add" : "Update"}</button>
                                        <button type="button" className="btn btn-cancel" onClick={(e) => this.clickFundRaisePurposeFunding("showFundingPurpose")}>Cancel</button>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                }

                <div id="accordion">
                    {fundRaiseFaq && fundRaiseFaq.length > 0 && fundRaiseFaq.map((faq, index) => {
                        return (
                            <div className="card">
                                {!faq.editFaqSection ? 
                                    <>
                                        <div className="card-header" id={"heading-" + index}>
                                            <h5>
                                                <a role="button" data-toggle="collapse" href={"#collapse-" + index} aria-expanded="true">{faq.question}</a>
                                                {donateNowConfig?.superAdminId === userData.userId &&
                                                    <div className="editableBtns">
                                                        <button className="btn" onClick={() => this.editFaq(faq.id)}><i className="iEditBox" /></button>
                                                        <button className="btn" onClick={() => this.deleteFaq(faq.id)}><i className="iTrashBin" /></button>
                                                    </div>
                                                }
                                            </h5>
                                        </div>
                                        <div id={"collapse-" + index} className={"collapse " + (openFaqSectionIndex === index ? "show" : "")} data-parent="#accordion" aria-labelledby={"heading-" + index}>
                                            <div className="card-body">
                                                <p>{faq.answer}</p>
                                            </div>
                                        </div>
                                    </> :
                                    <div className={"pjaddjobsec prjHmFR_purpose_form faqForm current"}>
                                        <div className={"fadeIn animated profeditmain collapse show"}>
                                            <div className="form-group">
                                                <input className="form-control" name={"faqQuestion"} type="text" placeholder="Type Question here.." value={faq.question} onChange={(event) => this.handleFaqEdit(event, faq.id, "QUESTION")} />
                                                {errors["faqQuestion"] && <span className="login-feedback-error mt-1" style={{ display: "block" }}>{errors["faqQuestion"]}</span>}
                                            </div>
                                            <div className="form-group">
                                                <textarea className="form-control" name={"faqAnswer"} placeholder="Type Answer here.." value={faq.answer} onChange={(event) => this.handleFaqEdit(event, faq.id, "ANSWER")} ></textarea>
                                                {errors["faqAnswer"] && <span className="login-feedback-error mt-1" style={{ display: "block" }}>{errors["faqAnswer"]}</span>}
                                            </div>
                                            <div className='actionBtnWrap mt-3'>
                                                <button type="button" className="btn btn-primary ok" onClick={() => this.editFaqSectionData(faq.id)}>Update</button>
                                                <button type="button" className="btn btn-cancel" onClick={(e) => this.cancelEditFaq()}>Cancel</button>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        )
                    })}
                    {fundRaiseFaq && fundRaiseFaq.length < 5 && donateNowConfig?.superAdminId === userData.userId &&
                        <div className={"pjaddjobsec prjHmFR_purpose_form faqForm" + (showFaqAddSection ? " current" : "")}>
                            <a href="javascript:void(0)" className="edtbtn btn collapser" onClick={(e) => this.clickFundRaisePurposeFunding("showFaqAddSection")}><i className="iEditBox"></i> Add Fund Raise FAQ</a>
                            <div className={"fadeIn animated profeditmain collapse" + (showFaqAddSection ? " show" : "")}>
                                <div className="form-group">
                                    <input className="form-control" name={"faqQuestion"} type="text" placeholder="Type Question here.." value={faqQuestion} onChange={this.handleChange} />
                                    {errors["faqQuestion"] && <span className="login-feedback-error mt-1" style={{ display: "block" }}>{errors["faqQuestion"]}</span>}
                                </div>
                                <div className="form-group">
                                    <textarea className="form-control" name={"faqAnswer"} placeholder="Type Answer here.." value={faqAnswer} onChange={this.handleChange} ></textarea>
                                    {errors["faqAnswer"] && <span className="login-feedback-error mt-1" style={{ display: "block" }}>{errors["faqAnswer"]}</span>}
                                </div>
                                <div className='actionBtnWrap mt-3'>
                                    <button type="button" className="btn btn-primary ok" onClick={this.submitFaqSectionData}>Add</button>
                                    <button type="button" className="btn btn-cancel" onClick={(e) => this.clickFundRaisePurposeFunding("showFaqAddSection")}>Cancel</button>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        )
    }
}

export default DonationAboutSection;